import { BaseContainerModel } from '../base-container.model';
import {bl_fi_generic_doc_hdr_RowClass} from '../../dbschema';

export class GenericDocHdrContainerModel extends BaseContainerModel {

  bl_fi_generic_doc_hdr: bl_fi_generic_doc_hdr_RowClass = new bl_fi_generic_doc_hdr_RowClass();
}
